// extracted by mini-css-extract-plugin
module.exports = {"meal":"MealItem_meal__2zolt","description":"MealItem_description__CTNue","price":"MealItem_price__1plYV"};